<template>
  <div>
    <b-modal ref="modalError"
             hide-footer
             title="Erreur">
		<lottie_error />
      <p class="my-4">{{ this.text_error }}</p>
    </b-modal>
    <div class="col-12 mt-4">
      <div class="valid_button">
        <button type="submit"
                class="btn btn-valid"
                @click="sendDatas">{{ $t("Button.validate") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "../../../event/event-bus.js";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default{
	name: "ValidStepMusic",
	components: {lottie_error},
	props: {
		id: Number,
		musicId: Number,
		modal: "",
	},
	data() {
		return {
			text_error: "",
		};
	},
	methods: {
		sendDatas() {
			let $this = this;
			$this.modal.show();
			let bodyFormData = new FormData();
			bodyFormData.append("_method", "put");
			bodyFormData.append("musicId", this.musicId);
			axios.post(BASE_URL + "/public/api/stepMusics/" + this.id,
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				}
			).then(function () {
				$this.modal.hide();
				EventBus.$emit("setStepMusicComplete", $this.id);
			})
				.catch(error => {
					this.text_error = this.$root.$t("Errors.message_project") + error;
					this.$refs.modalError.show();
				});
		},
	},
};
</script>

<style scoped>
  .btn-valid {
    background-color: var(--color-validation);
    border-color: var(--color-validation);
    color: var(--text-validation);
	border-radius: var(--small-border-radius);
  }
</style>
